module.exports = __webpack_public_path__ + "static/media/useCase73x.d5832cb0.png";